type Props = {
    width?: string | null;
    height?: string | null;
    color?: string | null;
};

export const CancelIcon = ({ width, height, color }: Props) => (
    <svg
        xmlns="https://www.w3.org/2000/svg"
        width={width || "17"}
        height={height || "17"}
        viewBox="0 0 17 17"
        fill="none"
    >
        <path
            d="M7 17L16.8995 7.10051"
            stroke={color || "#A8A8A8"}
            stroke-linecap="round"
            stroke-linejoin="round"
            fill={color || "#A8A8A8"}
        />
        <path
            d="M7 7.00001L16.8995 16.8995"
            stroke={color || "#A8A8A8"}
            stroke-linecap="round"
            stroke-linejoin="round"
            fill={color || "#A8A8A8"}
        />
    </svg>
);
